const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom: 16,
    '&:last-child': {
      paddingBottom: 0,
    },
    position: 'relative',
  },
  fieldContainer: {
    width: '100%',
    display: 'flex',
  },
  formControl: {
    width: '100%',
  },
  shrink: {
    fontSize: '5rem',
    transform: 'scale(1)',
    [theme.breakpoints.down('xs')]: {
      transform: 'scale(0.87)',
      whiteSpace: 'nowrap',
    },
  },
  label: {
    color: '#666666',
    fontSize: '1rem',
    lineHeight: '1rem',
    marginTop: 0,
    fontFamily: 'Calibre',
  },
  icon: {
    borderColor: theme.palette.border.lighter,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '100px',
    backgroundColor: theme.palette.background.lighter,
    padding: theme.spacing.unit,
    marginRight: theme.spacing.unit * 2.5,
    width: 40,
    height: 40,
  },
  value: {
    fontSize: '1rem',
    lineHeight: '1rem',
    fontSize: '1.125rem',
    paddingBottom: 0,
    marginBottom: theme.spacing.unit * 0.5,
    // The below div only appears on multiline text fields/textareas.
    // Unable to find a CSS override for the class name.
    '&& > div': {
      width: `calc(100% - ${theme.spacing.unit * 3.5}px)`,
    },
  },
  input: {
    paddingTop: 5,
    paddingBottom: theme.spacing.unit * 1.5,
    width: `calc(100% - ${theme.spacing.unit * 3.5}px)`,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 3,
    },
  },
  inputMultiline: {
    width: '100%',
  },
  help: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
  error: {
    color: theme.palette.error.main,
  },
  disabled: {
    color: '#6F6F6F',
  },
  clear: {
    position: 'absolute',
    right: 0,
    top: 20,
    fontSize: '1.375rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export default styles;
